export default "__VITE_ASSET__DQm2Kjto__"